import { isEqual } from 'lodash';
import { useEffect } from 'react';

import { usePrevious } from '@hivebrite/react-hooks';

import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';

import useTopicsMenuName from './useTopicsMenuName';
import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';

const useTopicsUserAuthorization = () => {
  const { itemsPerRow, userAuthorizationInfo } = useTopicsIndexContext();
  const menuName = useTopicsMenuName();

  const previousError = usePrevious(userAuthorizationInfo.error);

  useEffect(() => {
    if (!isEqual(previousError, userAuthorizationInfo.error)) {
      displayXhrError(userAuthorizationInfo.error);
    }
  }, [userAuthorizationInfo.error]);

  return {
    itemsPerRow,
    menuName,
  };
};

export default useTopicsUserAuthorization;
